import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './LessConfig.scss';
import Wrapper from 'components/Wrapper';

function LessConfig({ configs, onClick, params, onSave, onCancel }) {
    const [style, setStyle] = useState({ width: '110px' });

    useEffect(() => {
        if (configs.length !== 0) {
            var maxLegth = 0;
            const items = document.getElementsByClassName('allconfigs--config--title');

            for (var item of items) {
                const width = item.offsetWidth + 150;

                if (width > maxLegth) {
                    maxLegth = width;
                }
            }

            setStyle({ width: `${maxLegth}px` });
        }
    }, [configs.length]);

    function checkActiveParam(name, param, i) {
        if (params.find(e => e.name === name && (e.value).find(e => e === param))) {
            return <div className='allconfigs--config--items--item activeParam' key={i} onClick={() => onClick({ name, param })}>
                {param}
            </div>;
        } else {
            return <div className='allconfigs--config--items--item' key={i} onClick={() => onClick({ name, param })}>
                {param}
            </div>;
        }
    }

    return (<div className='allconfigs'>

        <Wrapper>
            {configs.length > 4 &&
          <div className='allconfigs--title'>
              <h3>
                Select Configuration
              </h3>
          </div>
            }

            {configs.map((conf, i) =>
                <div className='allconfigs--config' key={i}>
                    <div className='allconfigs--config--title' style={style}>
                        {conf.name}
                    </div>
                    <div className='allconfigs--config--items'>
                        {conf.value.map((param, i) => {
                            return checkActiveParam(conf.name, param, i);
                        }
                        )}
                    </div>
                </div>
            )}

        </Wrapper>

        {configs.length > 4 &&
            <div className='allconfigs--action'>
                <Wrapper>
                    {params.length !== 0 && <button className='allconfigs--action--cancel' onClick={() => onCancel()}>Cancel</button>}
                    <button className='allconfigs--action--save' onClick={() => onSave()}>Save</button>
                </Wrapper>
            </div>
        }

    </div>);
}

export default LessConfig;

LessConfig.propTypes = {
    configs: PropTypes.array.isRequired,
    params: PropTypes.array.isRequired,
    onClick: PropTypes.func.isRequired,
    onSave: PropTypes.func,
    onCancel: PropTypes.func
};
